export enum ServerErrorReason {
    OTHER = 'OTHER',
    DUPLICATED_DOCUMENT_IDENTIFIER = 'DUPLICATED_DOCUMENT_IDENTIFIER',
}
